import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
    console.log("ModalController connected");
  }

  show() {
    this.modalTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
  }

  hide() {
    this.modalTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }
}
